import {
  Datagrid,
  List,
  TextField,
  TextInput,
  EditButton,
  DeleteButton,
  FunctionField,
} from 'react-admin';
import { Box } from '@mui/material';

const tagFilters = [
  <TextInput
    sx={{ marginBottom: 1 }}
    source="name_q"
    label="resources.tag.fields.name"
    defaultValue=""
    key="name_q"
    alwaysOn
  />,
];

const ColorField = ({ record }: { record?: { color?: string | null } }) => {
  if (!record?.color) return null;
  return (
    <Box
      sx={{
        width: 24,
        height: 24,
        borderRadius: '4px',
        backgroundColor: record.color,
        border: '1px solid rgba(0,0,0,0.2)',
      }}
    />
  );
};

export const TagList = () => {
  return (
    <List filters={tagFilters}>
      <Datagrid
        bulkActionButtons={false}
        rowClick="edit"
        sort={{ field: 'id', order: 'DESC' }}
      >
        <TextField source="id" label="ID" />
        <TextField source="name" label="resources.tag.fields.name" />
        <FunctionField
          label="resources.tag.fields.color"
          render={(record: { color?: string | null }) => (
            <ColorField record={record} />
          )}
        />
        <EditButton />
        <DeleteButton mutationMode="pessimistic" />
      </Datagrid>
    </List>
  );
};
